import styled from 'styled-components';

import theme from '@theme';

export const Container = styled.div`
  min-width: 150px;
  width: 100%;
  height: 100%;
  position: relative;
  border-bottom: 1px solid #000;

  ${theme.mediaQueries.PHONE} {
    max-width: 100% !important;
    width: 100% !important;
  }

  @media (min-width: ${({ theme }) => theme.breakPoint.TABLET}) {
    border-bottom: 0px solid #000;
  }
`;

export const SelectedCompWrapper = styled.div<{ isError?: boolean }>`
  position: relative;
  display: flex;
  box-shadow: ${({ isError }) =>
    isError ? 'inset 0 0 0 3px #d95c5c' : 'none'};
`;
